import { createContext, useContext, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { searchProjects } from 'services/api/project';
import { config } from 'Constants';

const SearchContext = createContext();

export const useSearch = () => {
    return useContext(SearchContext);
};

const fetchProjects = async (searchParams) => {
    try {
        const response = await searchProjects(searchParams);
        return {
            result: response?.data?.result,
            totalCount: response?.data?.totalCount,
            totalPages: response?.data?.totalPages,
        };
    } catch (err) {
        throw err;
    }
};

export const SearchProvider = ({ children }) => {
    const initialDateRange = [null, dayjs()];
    const [searchQuery, setSearchQuery] = useState('');
    const [rating, setRating] = useState(0);
    const [responsibles, setResponsibles] = useState([]);
    const [dateRange, setDateRange] = useState(initialDateRange);
    const [projectStatus, setProjectStatus] = useState([]);
    const [demandStatus, setDemandStatus] = useState([]);
    const [tags, setTags] = useState([]); // ✅ Yeni
    const [win, setWin] = useState([]); // ✅ Yeni
    const [lose, setLose] = useState([]); // ✅ Yeni
    const [source, setSource] = useState([]); // ✅ Yeni
    const [winner, setWinner] = useState([]); // ✅ Yeni
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [isActive, setIsActive] = useState(true);
    const [data, setData] = useState({});

    const resetFilters = () => {
        setSearchQuery('');
        setRating(0);
        setResponsibles([]);
        setDateRange(initialDateRange);
        setProjectStatus([]);
        setDemandStatus([]);
        setTags([]);
        setWin([]);
        setLose([]);
        setSource([]);
        setWinner([]);
        setPage(1);
        setLimit(25);
        setIsActive(true);
    };

    const searchParams = {
        searchQuery,
        responsibles,
        dateRange,
        projectStatus,
        demandStatus,
        rating,
        isActive,
        page,
        limit,
        tags, // ✅ yeni parametreler
        win,
        lose,
        source,
        winner,
    };

    const queryInfo = useQuery({
        queryKey: ['searchProjects', searchParams],
        queryFn: () => fetchProjects(searchParams),
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        staleTime: 60000,
    });

    useEffect(() => {
        if (queryInfo.isSuccess) {
            setData(queryInfo.data);
        }
    }, [queryInfo]);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && config && config.demandStatusID) {
            const {
                demandStatusID: { duzeltilmeli, revizeBekleniyor, fiyatBekleniyor },
            } = config;
            const initialDemandStatus =
                user.role === 'superadmin'
                    ? [
                          { _id: duzeltilmeli, name: 'Düzeltilmeli' },
                          { _id: revizeBekleniyor, name: 'Revize Bekleniyor' },
                          { _id: fiyatBekleniyor, name: 'Fiyat Bekleniyor' },
                      ]
                    : [];
            setDemandStatus(initialDemandStatus.filter((el) => el !== null));
        }
    }, []);

    return (
        <SearchContext.Provider
            value={{
                rating,
                searchQuery,
                responsibles,
                dateRange,
                projectStatus,
                demandStatus,
                tags,
                win,
                lose,
                source,
                winner,
                page,
                limit,
                isActive,
                data,
                queryInfo,
                updateSearchQuery: setSearchQuery,
                updateRating: setRating,
                updateResponsibles: setResponsibles,
                updateDateRange: setDateRange,
                updateProjectStatus: setProjectStatus,
                updateDemandStatus: setDemandStatus,
                updateTags: setTags,
                updateWin: setWin,
                updateLose: setLose,
                updateSource: setSource,
                updateWinner: setWinner,
                updatePage: setPage,
                updateLimit: setLimit,
                updateIsActive: setIsActive,
                resetFilters,
            }}
        >
            {children}
        </SearchContext.Provider>
    );
};
